import clsx from "clsx";
import type { ReactNode, HTMLAttributes } from "react";
import { forwardRef } from "react";

import styles from "./subtitle.module.css";

type Props = HTMLAttributes<HTMLDivElement> & {
    children: ReactNode;
};

const Subtitle = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const { children, className, ...otherProps } = props;

    return (
        <div {...otherProps} ref={ref} className={clsx(styles.subtitle, className)}>
            {children}
        </div>
    );
});

Subtitle.displayName = "Subtitle";

export { Subtitle };
export type { Props as SubtitleProps };
